export default "__VITE_ASSET__3qhJBlIZ__"